import React from "react";
import { findAllAcademicPartWithFormTemplateBySemesterEvent } from "../../_events/academic_parts/find.event";
import { alertError } from "../../_utils/alerts";

export const useAcademicPartAllWithTemplatesBySemester = (semester) => {

    const [data, setData] = React.useState([]);

    const loadData = (s) => {
        findAllAcademicPartWithFormTemplateBySemesterEvent(s)
        .then(json => {
            setData(json.list);
        })
        .catch(err => {
            alertError(err.message);
        });
    }

    React.useEffect(() => {
        loadData(semester);
    }, [semester]);

    return { data, loadData };
}